import { API } from 'api';

import {
  ProvisionalSubmissionPayload,
  ProvisionalSubmissionResponse,
} from 'features/provisionalSubmissions/provisionalSubmissions.types';

export const postProvisionalSubmission = async (
  payload: ProvisionalSubmissionPayload,
): Promise<ProvisionalSubmissionResponse> => {
  const response = await API.post<ProvisionalSubmissionResponse>(
    'provisional_submissions/',
    payload,
  );
  return response.data;
};

export const approveProvisionalSubmission = async <TResponse, TData>(
  id: number,
  approvedData: TData,
  skipRedundancyCheck?: boolean,
): Promise<TResponse> => {
  const response = await API.post<TResponse>(
    `provisional_submissions/${id}/approve/`,
    { approvedData, ...(skipRedundancyCheck && { skipRedundancyCheck }) },
  );
  return response.data;
};

export const rejectProvisionalSubmission = async (
  id: number,
): Promise<ProvisionalSubmissionResponse> => {
  const response = await API.post<ProvisionalSubmissionResponse>(
    `provisional_submissions/${id}/reject/`,
    {},
  );
  return response.data;
};
